import type { KeyboardEvent } from 'react';
import styles from './SectionHeader.module.css';

interface SectionHeaderProps {
  title: string;
  count: number;
  onClear: () => void;
  collapsed?: boolean;
  onToggle?: () => void;
}

export default function SectionHeader({
  title,
  count,
  onClear,
  collapsed,
  onToggle,
}: SectionHeaderProps) {
  const isCollapsible = onToggle !== undefined;

  const handleClearClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClear();
  };

  const handleClearKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      e.stopPropagation();
      onClear();
    }
  };

  const badge = count > 0 && <span className={styles.badge}>{count}</span>;

  if (isCollapsible) {
    const clearSpan = count > 0 && (
      <span
        role="button"
        tabIndex={0}
        className={styles.clearLink}
        onClick={handleClearClick}
        onKeyDown={handleClearKeyDown}
      >
        Clear
      </span>
    );

    return (
      <button
        type="button"
        className={styles.sectionHeader}
        onClick={onToggle}
        aria-expanded={!collapsed}
      >
        <span className={styles.sectionTitle}>{title}</span>
        {badge}
        {clearSpan}
        <svg
          className={styles.chevron}
          data-collapsed={collapsed}
          width="12"
          height="12"
          viewBox="0 0 16 16"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="4 6 8 10 12 6" />
        </svg>
      </button>
    );
  }

  const clearBtn = count > 0 && (
    <button
      type="button"
      className={styles.clearLink}
      onClick={handleClearClick}
    >
      Clear
    </button>
  );

  return (
    <div className={styles.sectionHeader}>
      <span className={styles.sectionTitle}>{title}</span>
      {badge}
      {clearBtn}
    </div>
  );
}
